import {
  CANVAS_HISTORY_FAILED,
  CANVAS_HISTORY_REQUEST,
  CANVAS_HISTORY_SUCCESS,
} from "../../../../actions/Factory/Canvas/canvasHistory/constant";

const INIT_STATE = {
  loading: false,
  totalPage: 0,
  data: [],
  error: {
    isError: false,
    message: null,
  },
};

export const canvasHistoryReducer = function (
  state = INIT_STATE,
  action
) {
  switch (action?.type) {
    case CANVAS_HISTORY_REQUEST:
      return {
        loading: true,
        totalPage: 0,
        data: [],
        error: {
          isError: false,
          message: null,
        },
      };
    case CANVAS_HISTORY_SUCCESS:
      return {
        loading: false,
        data: action?.payload?.data,
        totalPage: action?.payload?.totalPage,
        error: {
          isError: false,
          message: null,
        },
      };
    case CANVAS_HISTORY_FAILED:
      const { isError = true, message = "Something Went Wrong" } =
        action?.payload?.error || {};
      return {
        loading: false,
        totalPage: 0,
        data: [],
        error: {
          isError: isError,
          message: message,
        },
      };
    default:
      return state;
  }
};
